import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbSteeringGearComponent } from '../kb-steering-gear.component';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, AppRoutingModule, AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, PageComponentModule, ProductListModule, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FacetNavigationModule } from '../../facet-navigation/facet-navigation.module';
import { KbDocumentGridItemModule } from '../../kb-product-list/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../../kb-product-list/kb-document-list/kb-document-list.module';
import { KbProductGridItemModule } from '../../kb-product-list/kb-product-grid-item/kb-product-grid-item.module';
import { KbProductListItemModule } from '../../kb-product-list/kb-product-list-item/kb-product-list-item.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';



@NgModule({
  declarations: [KbSteeringGearComponent],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbDocumentGridItemModule,
    KbDocumentListItemModule,
    FacetNavigationModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    KbPaginationModule,

    ConfigModule.withConfig({
      cmsComponents: {
        SteeringGearSearchFlexComponent: {
          component: KbSteeringGearComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)

  ]
})
export class SteeringGearModule { }
